export const legal = {
	disclaimer: {
		title: "免責事項",
		lastUpdated: "最終更新日",
		sections: {
			siteInfo: {
				title: "第1条（当サイトの情報について）",
				content: "当サイトに掲載されている情報については、可能な限り正確な情報を掲載するよう努めておりますが、誤情報が入り込んだり、情報が古くなっていることもございます。\n当サイトに掲載された内容によって生じた損害等の一切の責任を負いかねますのでご了承ください。",
			},
			appUsage: {
				title: "第2条（アプリケーションの利用について）",
				content: "当方が開発・提供するアプリケーションの利用により生じた、いかなる損害についても、当方は一切の責任を負いません。\nアプリケーションのダウンロード、インストール、および利用は、利用者自身の責任において行ってください。",
			},
			links: {
				title: "第3条（リンクについて）",
				content: "当サイトからリンクやバナーなどによって他のサイトに移動された場合、移動先サイトで提供される情報、サービス等について一切の責任を負いません。",
			},
			technicalIssues: {
				title: "第4条（技術的不具合について）",
				content: "当サイトおよびアプリケーションは、システムメンテナンスやサーバーの不具合、その他の理由により、予告なくサービスを停止する場合があります。\nこれらのサービス停止により生じた損害について、当方は一切の責任を負いません。",
			},
			thirdPartyServices: {
				title: "第5条（第三者サービスについて）",
				content: "当サイトおよびアプリケーションは、第三者が提供するサービス（広告、アナリティクス等）を利用する場合があります。\nこれらの第三者サービスの利用により生じた損害について、当方は一切の責任を負いません。",
			},
			copyright: {
				title: "第6条（著作権・知的財産権について）",
				content: "当サイトで提供するコンテンツ（文章、画像、動画、音声、プログラム等）の著作権その他の知的財産権は、当方または正当な権利を有する第三者に帰属します。\nこれらを無断で複製、改変、配布等することを禁じます。",
			},
			limitation: {
				title: "第7条（損害賠償の制限）",
				content: "当サイトおよびアプリケーションの利用に関連して利用者に生じた損害について、当方の故意または重大な過失による場合を除き、当方は一切の責任を負いません。",
			},
			changes: {
				title: "第8条（免責事項の変更）",
				content: "当方は、利用者に事前の通知なく、本免責事項を変更することがあります。\n変更後の免責事項は、当サイトに掲載した時点から効力を生じるものとします。",
			},
			contact: {
				title: "お問い合わせ",
				content: "本免責事項に関するお問い合わせは、下記の窓口までお願いいたします。",
			},
		},
		contactSection: {
			emailButton: "メールで問い合わせる",
		},
	},

	termsOfService: {
		title: "利用規約",
		lastUpdated: "最終更新日",
		sections: {
			application: {
				title: "第1条（適用）",
				content: "本規約は、下村一将（以下「当方」といいます。）が提供するアプリケーション及びサービス（以下「本サービス」といいます。）の利用条件を定めるものです。\nユーザーの皆様（以下「ユーザー」といいます。）には、本規約に従って本サービスをご利用いただきます。",
			},
			registration: {
				title: "第2条（利用登録）",
				content: "1. 本サービスにおいて登録を希望する者は、当方の定める方法によって利用登録を申請し、当方がこれを承認することによって、利用登録が完了するものとします。\n\n2. 当方は、以下の場合には、利用登録の申請を承認しないことがあり、その理由については一切の開示義務を負わないものとします。\n  • 利用登録の申請に際して虚偽の事項を届け出た場合\n  • 本規約に違反したことがある者からの申請である場合\n  • その他、当方が利用登録を相当でないと判断した場合",
			},
			prohibited: {
				title: "第3条（禁止事項）",
				content: "ユーザーは、本サービスの利用にあたり、以下の行為をしてはなりません。\n\n1. 法令または公序良俗に違反する行為\n2. 犯罪行為に関連する行為\n3. 当方、本サービスの他のユーザー、またはその他第三者のサーバーまたはネットワークの機能を破壊したり、妨害したりする行為\n4. 当方のサービスの運営を妨害するおそれのある行為\n5. 他のユーザーに関する個人情報等を収集または蓄積する行為\n6. 不正アクセスをし、またはこれを試みる行為\n7. 他のユーザーに成りすます行為\n8. 当方のサービスに関連して、反社会的勢力に対して直接または間接に利益を供与する行為\n9. 当方、本サービスの他のユーザーまたはその他の第三者の知的財産権、肖像権、プライバシー、名誉その他の権利または利益を侵害する行為\n10. その他、当方が不適切と判断する行為",
			},
			suspension: {
				title: "第4条（本サービスの提供の停止等）",
				content: "1. 当方は、以下のいずれかの事由があると判断した場合、ユーザーに事前に通知することなく本サービスの全部または一部の提供を停止または中断することができるものとします。\n  • 本サービスにかかるコンピュータシステムの保守点検または更新を行う場合\n  • 地震、落雷、火災、停電または天災などの不可抗力により、本サービスの提供が困難となった場合\n  • コンピュータまたは通信回線等が事故により停止した場合\n  • その他、当方が本サービスの提供が困難と判断した場合\n\n2. 当方は、本サービスの提供の停止または中断により、ユーザーまたは第三者が被ったいかなる不利益または損害についても、一切の責任を負わないものとします。",
			},
			termination: {
				title: "第5条（利用制限および登録抹消）",
				content: "1. 当方は、ユーザーが以下のいずれかに該当する場合には、事前の通知なく、ユーザーに対して、本サービスの全部もしくは一部の利用を制限し、またはユーザーとしての登録を抹消することができるものとします。\n  • 本規約のいずれかの条項に違反した場合\n  • 登録事項に虚偽の事実があることが判明した場合\n  • その他、当方が本サービスの利用を適当でないと判断した場合\n\n2. 当方は、本条に基づき当方が行った行為によりユーザーに生じた損害について、一切の責任を負いません。",
			},
			warranty: {
				title: "第6条（保証の否認および免責事項）",
				content: "1. 当方は、本サービスに事実上または法律上の瑕疵（安全性、信頼性、正確性、完全性、有効性、特定の目的への適合性、セキュリティなどに関する欠陥、エラーやバグ、権利侵害などを含みます。）がないことを明示的にも黙示的にも保証しておりません。\n\n2. 当方は、本サービスに起因してユーザーに生じたあらゆる損害について、当方の故意または重過失による場合を除き、一切の責任を負いません。\n\n3. 前項ただし書に定める場合であっても、当方は、当方の過失（重過失を除きます。）による債務不履行または不法行為によりユーザーに生じた損害のうち特別な事情から生じた損害（当方またはユーザーが損害発生につき予見し、または予見し得た場合を含みます。）について一切の責任を負いません。\n\n4. 当方は、本サービスに関して、ユーザーと他のユーザーまたは第三者との間において生じた取引、連絡または紛争等について一切責任を負いません。",
			},
			serviceChange: {
				title: "第7条（サービス内容の変更等）",
				content: "当方は、ユーザーへの事前の告知をもって、本サービスの内容を変更、追加または廃止することがあり、ユーザーはこれを承諾するものとします。",
			},
			termsChange: {
				title: "第8条（利用規約の変更）",
				content: "1. 当方は以下の場合には、ユーザーの個別の同意を要せず、本規約を変更することができるものとします。\n  • 本規約の変更がユーザーの一般の利益に適合するとき\n  • 本規約の変更が本サービス利用契約の目的に反せず、かつ、変更の必要性、変更後の内容の相当性その他の変更に係る事情に照らして合理的なものであるとき\n\n2. 当方はユーザーに対し、前項による本規約の変更にあたり、事前に、本規約を変更する旨及び変更後の本規約の内容並びにその効力発生時期を通知します。",
			},
			privacy: {
				title: "第9条（個人情報の取扱い）",
				content: "当方は、本サービスの利用によって取得する個人情報については、当方「プライバシーポリシー」に従い適切に取り扱うものとします。",
			},
			notification: {
				title: "第10条（通知または連絡）",
				content: "ユーザーと当方との間の通知または連絡は、当方の定める方法によって行うものとします。\n当方は、ユーザーから、当方が別途定める方式に従った変更届け出がない限り、現在登録されている連絡先が有効なものとみなして当該連絡先へ通知または連絡を行い、これらは、発信時にユーザーへ到達したものとみなします。",
			},
			assignment: {
				title: "第11条（権利義務の譲渡の禁止）",
				content: "ユーザーは、当方の書面による事前の承諾なく、利用契約上の地位または本規約に基づく権利もしくは義務を第三者に譲渡し、または担保に供することはできません。",
			},
			jurisdiction: {
				title: "第12条（準拠法・裁判管轄）",
				content: "1. 本規約の解釈にあたっては、日本法を準拠法とします。\n\n2. 本サービスに関して紛争が生じた場合には、当方の所在地を管轄する裁判所を専属的合意管轄とします。",
			},
			contact: {
				title: "お問い合わせ",
				content: "本規約に関するお問い合わせは、下記の窓口までお願いいたします。",
			},
		},
		contactSection: {
			emailButton: "メールで問い合わせる",
		},
	},

	privacyPolicy: {
		title: "プライバシーポリシー",
		lastUpdated: "最終更新日",
		intro: "下村一将（以下「運営者」といいます）は、運営者の提供するアプリケーション（以下「本アプリ」といいます）における、ユーザーの個人情報の取扱いについて、以下のとおりプライバシーポリシー（以下「本ポリシー」といいます）を定めます。",
		sections: {
			collection: {
				title: "1. 個人情報の収集",
				content: "本アプリでは、以下の情報を収集する場合があります：\n\n• デバイス情報（OS、端末の種類、言語設定など）\n• アプリの利用状況（使用頻度、機能の利用状況など）\n• クラッシュレポート情報\n• 広告識別子（IDFA/AAID）\n\nこれらの情報は、アプリの品質向上、不具合の修正、およびユーザー体験の改善を目的として収集されます。",
			},
			usage: {
				title: "2. 個人情報の利用目的",
				content: "収集した情報は、以下の目的で利用します：\n\n• アプリの提供・運営・改善\n• 不具合の調査と修正\n• ユーザーサポートの提供\n• 統計データの作成\n• 新機能の開発と改善\n• 広告の配信と効果測定",
			},
			thirdParty: {
				title: "3. 第三者サービスの利用",
				content: "本サイトおよび本アプリでは、以下の第三者サービスを利用しています：\n\n【広告サービス】\n• Google AdMob\n詳細：https://policies.google.com/privacy\n\n【分析サービス】\n• Google Analytics（本サイト）\n詳細：https://policies.google.com/privacy\n\n• Google Analytics for Firebase（本アプリ）\n詳細：https://firebase.google.com/support/privacy\n\n• Crashlytics\n詳細：https://firebase.google.com/support/privacy\n\nこれらのサービスは独自のプライバシーポリシーに基づいて情報を収集・利用します。",
			},
			disclosure: {
				title: "4. 個人情報の第三者提供",
				content: "運営者は、以下の場合を除き、ユーザーの個人情報を第三者に提供することはありません：\n\n• ユーザーの同意がある場合\n• 法令に基づく場合\n• 人の生命、身体または財産の保護のために必要がある場合であって、本人の同意を得ることが困難である場合\n• 国の機関もしくは地方公共団体またはその委託を受けた者が法令の定める事務を遂行することに対して協力する必要がある場合",
			},
			security: {
				title: "5. 個人情報の安全管理",
				content: "運営者は、個人情報の正確性及び安全性確保のため、セキュリティに万全の対策を講じています。ただし、インターネットを介した通信の完全な安全性を保証するものではありません。",
			},
			rights: {
				title: "6. ユーザーの権利",
				content: "ユーザーは、自身の個人情報について、開示、訂正、削除を求めることができます。また、広告識別子のリセットや、OSの設定から広告のトラッキングを制限することができます。\n\niOS: 設定 > プライバシーとセキュリティ > トラッキング\nAndroid: 設定 > Google > 広告",
			},
			dataRetention: {
				title: "7. データの保存期間",
				content: "収集したデータは、利用目的を達成するために必要な期間のみ保存されます。アプリをアンインストールすることで、端末上のデータは削除されます。ただし、分析サービス等に送信されたデータについては、各サービスのポリシーに従います。",
			},
			children: {
				title: "8. 子どものプライバシー",
				content: "本アプリは13歳未満の子どもを対象としていません。運営者は、13歳未満の子どもから意図的に個人情報を収集することはありません。",
			},
			changes: {
				title: "9. プライバシーポリシーの変更",
				content: "本ポリシーの内容は、法令その他本ポリシーに別段の定めのある事項を除いて、ユーザーに通知することなく変更することができるものとします。変更後のプライバシーポリシーは、本ページに掲載したときから効力を生じるものとします。",
			},
			contact: {
				title: "10. お問い合わせ",
				content: "本ポリシーに関するお問い合わせは、下記までお願いいたします。",
			},
		},
		contactSection: {
			emailButton: "メールで問い合わせる",
			responseNote: "※返信には数日お時間をいただく場合がございます",
		},
	},

	commercialLaw: {
		title: "特定商取引法に基づく表記",
		lastUpdated: "最終更新日",
		table: {
			seller: "販売事業者",
			operator: "運営責任者",
			address: "所在地",
			contact: "お問い合わせ",
			price: "販売価格",
			additionalFees: "商品以外の必要料金",
			paymentMethod: "支払方法",
			paymentTiming: "支払時期",
			deliveryTiming: "商品の引渡し時期",
			returnPolicy: "返品・交換・キャンセル",
			serviceValidity: "サービスの利用期限",
			requirements: "動作環境",
		},
		values: {
			sellerName: "下村一将",
			operatorName: "下村一将",
			addressDisclosure: "請求があった場合、速やかに開示いたします",
			contactEmailLabel: "メールアドレス",
			contactNote: "※お問い合わせはメールでお願いいたします",
			priceNote: "各アプリケーション内に表示\niOS: App Store内のアプリ内課金として表示されます\nAndroid: Google Play内のアプリ内課金として表示されます",
			additionalFeesNote: "インターネット接続料金、通信料等はお客様のご負担となります",
			paymentMethodNote: "iOS: App Store決済（Apple ID経由）\nAndroid: Google Play決済（Googleアカウント経由）\n※詳細は各ストアの決済規約に準じます",
			paymentTimingNote: "購入時即時決済",
			deliveryTimingNote: "決済完了後、即時利用可能",
			returnPolicyNote: "デジタルコンテンツの性質上、原則として返品・交換はお受けしておりません。\nただし、アプリケーションに重大な不具合がある場合はこの限りではありません。\n返金については各ストア（Apple・Google）の返金ポリシーに準じます。",
			serviceValidityNote: "サブスクリプション型の場合：購入期間に準じます\n買い切り型の場合：無期限（サービス終了まで）",
			requirementsNote: "iOS: iOS 17.0以降（アプリによって異なる場合があります）\nAndroid: Android 7.0以降（アプリによって異なる場合があります）\n詳細は各アプリのストアページをご確認ください",
		},
		notes: {
			title: "注意事項",
			items: [
				"本表記は、App Store・Google Play経由で提供されるアプリケーション内課金に関するものです。",
				"決済はすべてApple社・Google社のシステムを通じて行われます。",
				"価格は各ストア上で表示される価格が正式な販売価格となります。",
				"為替レートの変動等により、価格が変更される場合があります。",
			],
		},
		contactSection: {
			title: "お問い合わせ",
			description: "商品・サービスに関するお問い合わせは、下記までお願いいたします。",
			emailButton: "メールで問い合わせる",
			responseNote: "※返信には数日お時間をいただく場合がございます",
		},
	},
} as const;
